<script>
	import { Link } from "svelte-routing";
    import { slide } from "svelte/transition";
    import { quintOut } from 'svelte/easing';
    export let showNav;

</script>
{#if showNav}
<div id="fic--menu" transition:slide="{{delay:150, duration:400, easing:quintOut}}">
  <div class="fic--menu-container container">
    <nav class="fic--ident-global_nav" id="fic--ident-topNav">
      <ul>
          <!-- <li><b>All pages currently:</b></li> -->
          <li>
            <Link to="/" on:click={function(){showNav = !showNav}}>Home</Link>
          </li>

           <li>
            <Link  to="/exploringunderstory"  on:click={function(){showNav = !showNav}}>Exploring Understory</Link>
          </li>

          <li>
            <Link to="/ourmission"  on:click={function(){showNav = !showNav}}>Our mission</Link>
          </li>
          
          <li>
            <Link to="/about"  on:click={function(){showNav = !showNav}}>About</Link>
          </li>


          <li>
            <Link to="/mappingmycommunity" on:click={function(){showNav = !showNav}}>Mapping my community</Link>
          </li>

           <li>
            <Link to="/thecommunitymaps"  on:click={function(){showNav = !showNav}}>The community maps</Link>
          </li>

          <li>
            <Link to="/news"  on:click={function(){showNav = !showNav}}>News</Link>
          </li>
          <!--<li>
              <Link to="/tutorials" on:click={function(){showNav = !showNav}}>Tutorials</Link>
          </li>-->
          <li>
              <a href="https://map.understory.community/home">Login to maps</a>
           </li>
                  
      </ul>
    </nav>
  </div>
</div>
{/if}
